import React, { useState } from 'react';
import ContentCopy from '@mui/icons-material/ContentCopy';
import CheckIcon from '@mui/icons-material/Check';
import { IconButton } from '@mui/material';

type Props = {
  copyValue: string;
};

export const CopyIcon: React.FC<Props> = ({ copyValue }) => {
  const [copySuccess, setCopySuccess] = useState(false);

  const handleCopy = () => {
    if (copyValue) {
      navigator.clipboard.writeText(copyValue);
      setCopySuccess(true);
      setTimeout(() => setCopySuccess(false), 3000);
    }
  };

  return (
    <IconButton onClick={handleCopy} disabled={copySuccess} color="primary">
      {copySuccess ? (
        <CheckIcon sx={{ color: 'success.contrastText' }} />
      ) : (
        <ContentCopy />
      )}
    </IconButton>
  );
};
